module.exports = __webpack_public_path__ + "static/media/bell.5659c3c9.svg";